<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="row">
          <div class="col-10">
            <ez-input v-model="item.name" :error="errors['name']">Name</ez-input>
          </div>
          <div class="col-2">
            <ez-toggle v-model="item.dead" :error="errors['dead']">Dead</ez-toggle>
          </div>
        </div>
        <ez-s3-image v-if="item.image" :item="item.image" />
      </div>
      <div class="col-12 col-sm-6">
        <ez-text-area-md v-model="item.description" :error="errors['description']" :rows="4">Description</ez-text-area-md>
        <div v-if="item.personality && item._id">
          <ez-text-area-md v-model="item.personality.traits" :error="errors['personality.traits']" :rows="4">Personality Traits</ez-text-area-md>
          <ez-text-area-md v-model="item.personality.ideals" :error="errors['personality.ideals']" :rows="4">Ideals</ez-text-area-md>
          <ez-text-area-md v-model="item.personality.bonds" :error="errors['personality.bonds']" :rows="4">Bonds</ez-text-area-md>
          <ez-text-area-md v-model="item.personality.flaws" :error="errors['personality.flaws']" :rows="4">Flaws</ez-text-area-md>
        </div>
      </div>
    </div>

    <div v-if="errors['message']" class="alert alert-danger" role="alert">
      {{errors['message']}}
    </div>
  </div>
</template>

<script>
import EzInput from "../shared/_VueEzInput.vue";
import EzToggle from "../shared/_VueEzToggle.vue";
import EzTextAreaMd from "../shared/_VueEzTextAreaMd.vue";

export default {
  name: "character-form",
  components: {
    EzInput,
    EzTextAreaMd,
    EzToggle
  },
  props: ["item", "errors"]
};
</script>

<style lang="scss" scoped>
img {
  max-height: 14.4em;
}
</style>
